import React from 'react';
import CardDeckStandard from './CardDeckStandard';
import CardDeckCta from './CardDeckCta';

const CardDeck = ({ component, heading, headingSize, subheading, kicker, cards, backgroundColor, type, podcastListing }) => {
  switch (type ?? component?.type) {
    case ('cta-cards'):
      return <CardDeckCta podcastListing={podcastListing} cards={cards ?? component?.post} noTopPadding={component?.noTopPadding} noBottomPadding={component?.noBottomPadding} />
    default:
      return (
        <CardDeckStandard
          component={component}
          heading={heading}
          headingSize={headingSize}
          subheading={subheading}
          kicker={kicker}
          cards={cards}
          backgroundColor={backgroundColor}
        />
      )
  }
};

CardDeck.displayName = 'CardDeck';

export default CardDeck
